// *** Display data system of record ***

export const PRODUCT_CATEGORIES = [
  "Beauty & Personal Care",
  "Books",
  "Clothing",
  "Electronics",
  "Food & Beverages",
  "Home & Kitchen",
  "Health & Wellness",
  "Jewelry",
  "Office Products",
  "Pet Supplies",
  "Sports & Outdoors",
  "Toys & Games",
];

// *** Platform Fees ***

export const BRAND_FEE_PERCENTAGE = 0.01; // 1% fee added when Brand funds collab
export const CREATOR_FEE_PERCENTAGE = 0.01; // 1% fee deducted when crediting Creator earnings

// *** Collab Expiration ***

export const COLLAB_EXPIRATION_DAYS_DEFAULT = 14; // 2 weeks
export const COLLAB_EXPIRATION_WARNING_DAYS = 3; // Show warning when <3 days left
